import {AnyEvent, JOB_FILE_UPLOAD_UPDATED, JobFileUploadUpdatedEvent} from '../type';

export default function jobFileUploadUpdated(payload: JobFileUploadUpdatedEvent['payload']): AnyEvent {
  return {
    type: JOB_FILE_UPLOAD_UPDATED,
    payload,
  }
}